module.exports = __webpack_public_path__ + "img/icon_map_63_on_001.0a8ea305.png";